import React from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const fadeRight = {
  hidden: { opacity: 0, x: 60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

const ServiceAreas = () => {
  const areas = [
    {
      title: "Northern California",
      points: ["Bay Area"],
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1612559.6147850866!2d-123.73979064113627!3d37.87127467882183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808583a3a688d7b5%3A0x8c891b8457461fa9!2sSan%20Francisco%20Bay%20Area%2C%20CA!5e0!3m2!1sen!2sus!4v1769965625200!5m2!1sen!2sus"
    },
    {
      title: "Southern California",
      points: [
        "Orange County",
        "Los Angeles County",
        "Santa Clarita Valley",
        "San Diego County"
      ],
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3381458.8456166196!2d-120.42612279612054!3d34.14107392456395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c325a785c9a649%3A0x7223c333f40c68d8!2sSouthern%20California%2C%20CA!5e0!3m2!1sen!2sus!4v1769684431343!5m2!1sen!2sus"
      }
  ];

  return (
    <section id="service-areas" className="bg-[#f8f9fa] py-12 px-6 -mt-6">

      {/* Section Header */}
      <motion.div
        className="max-w-4xl mx-auto text-center mb-10"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0 }}
      >
        <motion.p
          variants={fadeUp}
          className="text-[#6c757d] uppercase tracking-wider text-xs md:text-sm font-semibold"
        >
          Service Areas
        </motion.p>
        <motion.h2
          variants={fadeUp}
          className="mt-2 text-3xl md:text-4xl font-bold text-[#212529]"
        >
          Where We Work
        </motion.h2>
      </motion.div>

      {/* Two Columns */}
      <div className="max-w-4xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8">

          {/* Northern California — slides in from left */}
          <motion.div
            variants={fadeLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0 }}
            className="group relative bg-white rounded-xl shadow-md border border-[#dee2e6] p-6 flex flex-col items-center text-center
                       transition-all duration-500 transform hover:scale-105
                       hover:bg-[#212529] hover:shadow-[0_0_25px_rgba(0,0,0,0.2)]"
          >
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-[#212529] group-hover:text-white transition-colors duration-500">
              {areas[0].title}
            </h3>
            <div className="w-full rounded-xl overflow-hidden shadow-md mb-4">
              <iframe
                src={areas[0].mapSrc}
                width="100%"
                height="200"
                className="border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={areas[0].title}
              />
            </div>
            <div className="text-[#495057] group-hover:text-white transition-colors duration-300 flex flex-col gap-1">
              <span className="text-sm md:text-base">{areas[0].points[0]}</span>
            </div>
          </motion.div>

          {/* Southern California — slides in from right */}
          <motion.div
            variants={fadeRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0 }}
            className="group relative bg-white rounded-xl shadow-md border border-[#dee2e6] p-6 flex flex-col items-center text-center
                       transition-all duration-500 transform hover:scale-105
                       hover:bg-[#212529] hover:shadow-[0_0_25px_rgba(0,0,0,0.2)]"
          >
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-[#212529] group-hover:text-white transition-colors duration-500">
              {areas[1].title}
            </h3>
            <div className="w-full rounded-xl overflow-hidden shadow-md mb-4">
              <iframe
                src={areas[1].mapSrc}
                width="100%"
                height="200"
                className="border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={areas[1].title}
              />
            </div>
            <div className="text-[#495057] group-hover:text-white transition-colors duration-300 flex flex-col gap-1">
              <span className="text-sm md:text-sm">{areas[1].points.slice(0, 2).join(" • ")}</span>
              <span className="text-sm md:text-sm">{areas[1].points.slice(2).join(" • ")}</span>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;